import React from 'react';

import { DeleteBin5Line } from '@assets/icons';
import {
  ListingSearchRoomInterface,
  ListingSearchRoomItemProps,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import ListingSearchGuestItem from '@components/ui/search/SearchGuest/SearchGuestItem';
import CustomIcon from '@components/utils/CustomIcon';

import {
  ResponsiveRoomDeleteButton,
  ResponsiveRoomLabel,
  ResponsiveRoomMain,
  StyledListingGuestRoom,
} from './ResponsiveListingSearchStyle';

interface ResponsiveRoomInterface {
  removeRoom: () => void;
  elementRef: React.RefObject<HTMLDivElement> | null | undefined;
  rooms?: Array<ListingSearchRoomInterface>;
  min?: number;
}

const ResponsiveListingRoom: React.FC<
  ListingSearchRoomInterface &
    ListingSearchRoomItemProps &
    ResponsiveRoomInterface
> = (props) => {
  const {
    childGuestCount,
    adultGuestCount,
    childrenList,
    handleChildNumberIncrement,
    handleChildNumberDecrement,
    handleAdultNumberIncrement,
    handleAdultNumberDecrement,
    changeChildAge,
    closable,
    removeRoom,
    title,
    elementRef,
    min,
  } = props;

  return (
    <StyledListingGuestRoom>
      <div className={`responsive-room-header room-${title}`} ref={elementRef}>
        <ResponsiveRoomLabel>{title}</ResponsiveRoomLabel>
        {closable ? (
          <ResponsiveRoomDeleteButton onClick={() => removeRoom()}>
            <CustomIcon
              paletteColor='grey800'
              icon={DeleteBin5Line}
              fontSize={20}
            />
          </ResponsiveRoomDeleteButton>
        ) : null}
      </div>

      <ResponsiveRoomMain>
        <ListingSearchGuestItem
          title='Yetişkin'
          subTitle='15+ Yaş'
          handleDecrement={handleAdultNumberDecrement}
          handleIncrement={handleAdultNumberIncrement}
          count={adultGuestCount}
          min={min}
        />

        <ListingSearchGuestItem
          title='Çocuk'
          subTitle='0-15 Yaş'
          handleDecrement={handleChildNumberDecrement}
          handleIncrement={handleChildNumberIncrement}
          count={childGuestCount}
          isChildCounter={true}
          childrenList={childrenList}
          changeChildAge={changeChildAge}
        />
      </ResponsiveRoomMain>
    </StyledListingGuestRoom>
  );
};

export default React.memo(ResponsiveListingRoom);
